export default __webpack_public_path__ + "static/media/25110802.0fd153d6.png";